import { render } from "./OptionsPanelButton.vue?vue&type=template&id=01bd9fd4"
import script from "./OptionsPanelButton.vue?vue&type=script&lang=js"
export * from "./OptionsPanelButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__